import { Fragment, useState } from "react";
import FilterTab from "../../UI/FilterTab/FilterTab";
import classes from "./AllOrders.module.scss";
import Order from "./Order/Order";

const ORDERTYPES = ["Order History", "Order on hold", "Order offline"];

const AllOrders = () => {
  const [ordersType, setOrdersType] = useState("Order History");

  const onChangeFilter = (newValue) => {
    setOrdersType(newValue);
  };

  return (
    <Fragment>
      <FilterTab
        group="dishes"
        options={ORDERTYPES}
        selectedOption={ordersType}
        onChangeFilter={onChangeFilter}
      />
      <div className={classes.Orders}>
        <Order
          customerName="John Doe"
          tableNum="T-32"
          orderDate={new Date().toLocaleString()}
          orderNote="Waiting for family."
          items={[
            { name: "Asian Chicken Soup", quantity: 4, size: "Medium" },
            { name: "Asian Chicken Soup", quantity: 4, size: "Medium" },
            { name: "Asian Chicken Soup", quantity: 4, size: "Medium" },
          ]}
        />
        <Order
          customerName="John Doe"
          tableNum="T-32"
          orderDate={new Date().toLocaleString()}
          orderNote="Waiting for family."
          items={[
            { name: "Asian Chicken Soup", quantity: 4, size: "Medium" },
            { name: "Asian Chicken Soup", quantity: 4, size: "Medium" },
          ]}
        />
        <Order
          customerName="John Doe"
          tableNum="T-32"
          orderDate={new Date().toLocaleString()}
          orderNote="Waiting for family."
          items={[
            { name: "Asian Chicken Soup", quantity: 4, size: "Medium" },
            { name: "Asian Chicken Soup", quantity: 4, size: "Medium" },
          ]}
        />
      </div>
    </Fragment>
  );
};

export default AllOrders;
